
import { Minus, Plus } from 'lucide-vue'
import customLabel from '@/components/common/custom-label'
import btnPrimary from '@/components/common/buttons/btn-primary'
import * as shoppingCartLS from '@/lib/shoppingCartLS'
import { isMobileScreen } from '@/lib/utils'

export default {
  name: 'ProductCard',
  components: {
    customLabel,
    btnPrimary,
    Minus,
    Plus,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: 'auto',
    },
    withHover: {
      type: Boolean,
    },
  },
  data() {
    return {
      total: 1,
      selectedFormatIndex: 0,
      isMobile: false,
      link_storage: process.env.VUE_APP_ROOT_STORAGE,
    }
  },
  computed: {
    computedType() {
      if (this.type !== 'auto') return this.type

      let type = 'o'
      switch (this.item.product_type) {
        case 'App\\Models\\Box':
          type = 'b'
          break
        case 'App\\Models\\GourmetProduct':
          type = 'g'
          break
        case 'App\\Models\\Alcohol':
          type = 'a'
          break
        case 'App\\Models\\Wine':
          type = 'w'
          break
        case 'App\\Models\\Blog':
          type = 'blog'
          break
        case 'App\\Models\\Event':
          type = 'event'
          break
      }
      return type
    },
    hasStock() {
      if (this.isGourmetProduct) {
        return this.item.formats?.some((format) => format.stock > 0) || false
      }
      if (this.computedType === 'blog' || this.computedType === 'event') {
        return true
      }
      return this.item.stock > 0
    },
    computedPrice() {
      if (this.isGourmetProduct) {
        return this.selectedFormat?.price || null
      }
      return this.item.price
    },
    selectedFormat() {
      return this.item.formats?.[this.selectedFormatIndex]
    },
    isGourmetProduct() {
      return this.item.product_type === 'App\\Models\\GourmetProduct'
    },
  },
  created() {},
  mounted() {
    this.$bus.$on('reload', () => {
      this.reloadProuct()
    })
    this.reloadProuct()

    window.addEventListener('resize', this.handleWindowResize)
    this.isMobile = isMobileScreen()
  },
  unmounted() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleWindowResize() {
      this.isMobile = isMobileScreen()
    },
    reloadProuct() {
      const productLS = shoppingCartLS.findProduct(this.item.sku)
      this.total = productLS ? productLS.qty : 1
    },
    addCart() {
      let item = { ...this.item, price: this.computedPrice }
      if (this.isGourmetProduct) {
        item = {
          ...item,
          sku: this.selectedFormat.sku,
          stock: this.selectedFormat.stock,
        }
      }
      this.$bus.$emit('cart/update', {
        ...item,
        qty: this.total,
        previusQuantity: this.total,
      })
    },
    formatPrice(value) {
      const simbol = '$'
      const val = (value / 1).toFixed(0).replace('.', ',')
      return simbol + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    add() {
      const stock =
        this.selectedFormat?.is_unit_sales === 1
          ? this.selectedFormat.stock
          : this.item.stock
      if (this.total < stock) this.total++
    },
    remove() {
      this.total--
    },
    prevFormat() {
      if (this.selectedFormatIndex === 0) {
        this.selectedFormatIndex = this.item.formats.length - 1
        return
      }
      this.selectedFormatIndex--
    },
    nextFormat() {
      if (this.selectedFormatIndex + 1 === this.item.formats.length) {
        this.selectedFormatIndex = 0
        return
      }
      this.selectedFormatIndex++
    },
    getItemSubtitle(item) {
      let subtitle = ''
      if (item.description_card && item.description_card.length) {
        subtitle = item.description_card
      } else {
        subtitle = item.brand?.name || item.brand
        if (item.year) {
          subtitle += `, ${item.year}`
        }
      }
      return subtitle
    },
    computedLink(slug) {
      if (this.computedType === 'blog') {
        return '/blog/' + slug
      } else if (this.computedType === 'event') {
        return '/eventos/' + slug
      } else {
        return '/productos/' + slug + '?t=' + this.computedType
      }
    },
  },
}
